import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {Injector, NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {app, setInjector} from "../services";
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {PageNotFoundComponent} from './components/common/page-not-found/page-not-found.component';
import {DashboardComponent} from './components/pages/dashboard/dashboard.component';
import {LoginIriasComponent} from './components/modals/login-irias/login-irias.component';
import {LinkComponent} from './components/modals/link/link.component';
import {TopbarComponent} from './components/common/topbar/topbar.component';
import {CopyComponent} from './components/modals/copy/copy.component';
import {PasswordResetComponent} from "./components/modals/password-reset/password-reset.component";
import {PasswordComponent} from "./components/modals/password/password.component";
import {AppLoaderComponent} from './components/common/app-loader/app-loader.component';
import {LoaderInterceptorService} from "./services/interceptors/loader-interceptor.service";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {RippleModule} from "primeng/ripple";
import {TableModule} from "primeng/table";
import {FileUploadModule} from "primeng/fileupload";
import {ToastModule} from "primeng/toast";
import {CardModule} from "primeng/card";
import {TabViewModule} from "primeng/tabview";
import {MessageModule} from "primeng/message";
import {InputTextModule} from "primeng/inputtext";
import {PasswordModule} from "primeng/password";
import {DropdownModule} from "primeng/dropdown";
import {ChipsModule} from "primeng/chips";
import {ConfirmationService, MessageService} from "primeng/api";
import {DialogService} from "primeng/dynamicdialog";
import {ChartModule} from "primeng/chart";
import {MenuModule} from "primeng/menu";
import {MenubarModule} from "primeng/menubar";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {DialogModule} from "primeng/dialog";
import {PanelModule} from "primeng/panel";
import {SidebarModule} from "primeng/sidebar";
import {TreeModule} from "primeng/tree";
import {AccordionModule} from "primeng/accordion";
import {ToolbarModule} from "primeng/toolbar";
import {RadioButtonModule} from "primeng/radiobutton";
import {TooltipModule} from "primeng/tooltip";
import {CheckboxModule} from "primeng/checkbox";
import {PanelMenuModule} from "primeng/panelmenu";
import {OverlayPanelModule} from "primeng/overlaypanel";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {ToggleButtonModule} from "primeng/togglebutton";
import {CalendarModule} from "primeng/calendar";
import {InputSwitchModule} from "primeng/inputswitch";
import {SelectButtonModule} from "primeng/selectbutton";
import {InplaceModule} from "primeng/inplace";
import {MultiSelectModule} from "primeng/multiselect";
import {ScrollPanelModule} from "primeng/scrollpanel";
import {SplitButtonModule} from "primeng/splitbutton";
import {TriStateCheckboxModule} from "primeng/tristatecheckbox";
import {InputTextareaModule} from "primeng/inputtextarea";
import {FilterPipe} from './pipes/filter.pipe';
import {ProjectsComponent} from './components/pages/projects/projects.component';
import {ProjectDetailComponent} from './components/pages/projects/project-detail/project-detail.component';
import {ProjectsResolver} from "./resolvers/projects.resolver";
import { NewProjectComponent } from './components/modals/new-project/new-project.component';
import {InputMaskModule} from "primeng/inputmask";
import {ListboxModule} from "primeng/listbox";
import {InputNumberModule} from "primeng/inputnumber";

@NgModule({
    declarations: [
		AppComponent,
		PageNotFoundComponent,
		DashboardComponent,
		PasswordComponent,
		PasswordResetComponent,
		LoginIriasComponent,
        LinkComponent,
        TopbarComponent,
        CopyComponent,
        AppLoaderComponent,
        FilterPipe,
        ProjectsComponent,
        ProjectDetailComponent,
        NewProjectComponent
    ],
	imports: [
		CommonModule,
		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		ReactiveFormsModule,
		HttpClientModule,
		TableModule,
		FormsModule,
		DropdownModule,
		InputTextModule,
		ChipsModule,
		ChartModule,
		ToastModule,
		MenuModule,
		CardModule,
		RippleModule,
		TabViewModule,
		PasswordModule,
		FileUploadModule,
		MessageModule,
		TableModule,
		FileUploadModule,
		ToastModule,
		CardModule,
		TabViewModule,
		MessageModule,
		InputTextModule,
		PasswordModule,
		DropdownModule,
		ChipsModule,
		MenubarModule,
		ProgressSpinnerModule,
		DialogModule,
		PanelModule,
		SidebarModule,
		TreeModule,
		AccordionModule,
		ToolbarModule,
		RadioButtonModule,
		TooltipModule,
		CheckboxModule,
		PanelMenuModule,
		OverlayPanelModule,
		ConfirmDialogModule,
		ToggleButtonModule,
		CalendarModule,
		InputSwitchModule,
		SelectButtonModule,
		InplaceModule,
		MultiSelectModule,
		ScrollPanelModule,
		SplitButtonModule,
		TriStateCheckboxModule,
		InputTextareaModule,
		InputMaskModule,
		ListboxModule,
		InputNumberModule
	],
    providers: [
        CdkVirtualScrollViewport,
        MessageService, DialogService, ConfirmationService, ProjectsResolver,
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptorService, multi: true }
    ],
    bootstrap: [AppComponent]
})

export class AppModule {
	constructor(_injector: Injector) {
		//Set the Injector to be able to open modal in static functions
		if (app) {
			console.error('Programming error: AppInjector was already set');
		} else {
			setInjector(_injector);
		}
	}
}
